export interface CompetenceIndicator {
  id: string;
  code: string;
  name_uz: string;
  name_ru: string;
  description_uz: string;
  description_ru: string;
}

export interface CompetenceArea {
  id: number;
  code: string;
  title_uz: string;
  title_ru: string;
  weight: number; // percentage (sum = 100%)
  icon: string;
  indicatorsCount: number;
  description_uz: string;
  description_ru: string;
  indicators: CompetenceIndicator[];
}

export interface AssessmentQuestion {
  id: string;
  areaId: number;
  difficulty: number; // IRT difficulty parameter b: -2.0 to +2.0
  discrimination: number; // IRT discrimination parameter a: 0.5 to 2.5
  question_uz: string;
  question_ru: string;
  options: {
    id: string;
    text_uz: string;
    text_ru: string;
    isCorrect: boolean;
  }[];
  explanation_uz: string;
  explanation_ru: string;
}

export interface ScenarioTask {
  id: string;
  areaId: number;
  title_uz: string;
  title_ru: string;
  scenario_uz: string;
  scenario_ru: string;
  keywords_uz: string[];
  keywords_ru: string[];
  sampleExpertAnswer_uz: string;
  sampleExpertAnswer_ru: string;
  maxScore: number;
}

export const UZ_DIG_COMP_AREAS: CompetenceArea[] = [
  {
    id: 1,
    code: 'DIG_DATA',
    title_uz: "Axborot va ma'lumotlar savodxonligi",
    title_ru: "Информационная грамотность и работа с данными",
    weight: 15,
    icon: '📊',
    indicatorsCount: 7,
    description_uz: "Ma'lumotlarni qidirish, filtrlash, ishonchliligini tahlil qilish, saqlash va tuzilmali boshqarish.",
    description_ru: "Поиск, фильтрация, критическая оценка достоверности, структурирование и хранение данных.",
    indicators: [
      { id: '1.1', code: 'DATA_SEARCH', name_uz: "Raqamli qidiruv strategiyalari", name_ru: "Стратегии цифрового поиска", description_uz: "Axborot qidiruv tizimlarida ilg'or filtrlardan foydalanish", description_ru: "Использование расширенных поисковых фильтров и запросов" },
      { id: '1.2', code: 'DATA_EVAL', name_uz: "Axborot ishonchliligini baholash", name_ru: "Оценка достоверности информации", description_uz: "Manbalar xolisligi, fakt-cheking va feyklarni aniqlash", description_ru: "Проверка источников, фактчекинг и выявление дезинформации" },
      { id: '1.3', code: 'DATA_STRUCT', name_uz: "Ma'lumotlarni strukturalash (Excel/SQL)", name_ru: "Структурирование данных (Excel/SQL)", description_uz: "Jadval va ma'lumotlar bazalarida tartibga solish", description_ru: "Организация таблиц и базовых баз данных" },
      { id: '1.4', code: 'DATA_STORAGE', name_uz: "Bulutli saqlash va zaxiralash", name_ru: "Облачное хранилище и бэкапы", description_uz: "Ma'lumotlar xavfsiz arxivi va sinxronizatsiyasi", description_ru: "Безопасное архивирование и синхронизация в облаке" },
      { id: '1.5', code: 'DATA_VISUAL', name_uz: "Ma'lumotlarni vizuallashtirish", name_ru: "Визуализация данных", description_uz: "Diagrammalar, infografikalar va dashboardlar qurish", description_ru: "Построение отчетов, дашбордов и инфографики" },
      { id: '1.6', code: 'DATA_CLEAN', name_uz: "Ma'lumotlarni tozalash va tayyorlash", name_ru: "Очистка и нормализация данных", description_uz: "Dublikatlarni va noto'g'ri qiymatlarni bartaraf etish", description_ru: "Удаление аномалий, дублей и пропусков в данных" },
      { id: '1.7', code: 'DATA_GOV', name_uz: "Korporativ ma'lumotlar boshqaruvi", name_ru: "Управление корпоративными данными", description_uz: "Fayllar nomenklaturasi va kirish huquqlarini belgilash", description_ru: "Регламенты доступа и классификации документов" },
    ]
  },
  {
    id: 2,
    code: 'DIG_COMM',
    title_uz: "Muloqot va raqamli hamkorlik",
    title_ru: "Цифровая коммуникация и коллаборация",
    weight: 12,
    icon: '🤝',
    indicatorsCount: 6,
    description_uz: "Zamonaviy raqamli vositalar orqali professional aloqa, jamoaviy loyihalarni boshqarish va netiket.",
    description_ru: "Профессиональная коммуникация через цифровые каналы, таск-трекеры, видеоконференции и этикет.",
    indicators: [
      { id: '2.1', code: 'COMM_CHANNELS', name_uz: "Korporativ messenjerlar va email", name_ru: "Корпоративные мессенджеры и email", description_uz: "Slack, Telegram, Teams va elektron pochtadan samarali foydalanish", description_ru: "Культура деловой переписки, треды и каналы связи" },
      { id: '2.2', code: 'COMM_COLLAB', name_uz: "Birgalikda ishlash vositalari", name_ru: "Инструменты совместной работы", description_uz: "Google Workspace, Miro, Notion da bir vaqtda tahrirlash", description_ru: "Совместное редактирование документов и досок задач" },
      { id: '2.3', code: 'COMM_MEET', name_uz: "Video-konferensiyalar o'tkazish", name_ru: "Организация видеоконференций", description_uz: "Zoom/Meet orqali masofaviy uchrashuvlarni boshqarish", description_ru: "Модерация онлайновых совещаний, шеринг экрана" },
      { id: '2.4', code: 'COMM_NETIQUETTE', name_uz: "Raqamli etika va netiket", name_ru: "Сетевой этикет и цифровая этика", description_uz: "Xabarlarning professional tili va vaqt mezonlariga rioya", description_ru: "Профессиональный тон, соблюдение цифровых границ" },
      { id: '2.5', code: 'COMM_IDENTITY', name_uz: "Raqamli profil va reputatsiya", name_ru: "Управление цифровым профилем", description_uz: "Professional tarmoqlarda kompaniya va shaxsiy imij", description_ru: "Профиль в LinkedIn/HH, цифровая репутация" },
      { id: '2.6', code: 'COMM_CITIZEN', name_uz: "Davlat interaktiv xizmatlari (my.gov.uz)", name_ru: "Государственные электронные сервисы", description_uz: "Yagona portal va davlat xizmatlaridan foydalanish", description_ru: "Взаимодействие с электронным правительством" },
    ]
  },
  {
    id: 3,
    code: 'DIG_CONTENT',
    title_uz: "Raqamli kontent yaratish",
    title_ru: "Создание цифрового контента",
    weight: 14,
    icon: '✍️',
    indicatorsCount: 6,
    description_uz: "Matn, grafika, multimediya kontentlarini yaratish, intellektual mulk va dasturlash asoslari.",
    description_ru: "Создание текстов, отчетов, мультимедиа, основы скриптов/кода и защита авторских прав.",
    indicators: [
      { id: '3.1', code: 'CONT_DOCS', name_uz: "Professional taqdimot va hisobotlar", name_ru: "Деловые презентации и аналитические отчеты", description_uz: "Zamonaviy formatlarda taqdimot va tahliliy hisobot tayyorlash", description_ru: "Форматирование презентаций, инфографика и стили" },
      { id: '3.2', code: 'CONT_MEDIA', name_uz: "Grafik va audio/video tahrirlash", name_ru: "Графический и медиа контент", description_uz: "Canva, Figma va oddiy video muharrirlarda ishlash", description_ru: "Базовый дизайн и обработка медиаматериалов" },
      { id: '3.3', code: 'CONT_IP', name_uz: "Mualliflik huquqi va litsenziyalar", name_ru: "Авторское право и лицензии", description_uz: "Creative Commons, intellektual mulk qonunchiligi", description_ru: "Понимание лицензий ПО, прав на контент и шрифты" },
      { id: '3.4', code: 'CONT_CODE', name_uz: "Dasturlash va avtomatlashtirish asoslari", name_ru: "Основы программирования и скриптов", description_uz: "Python/VBA asoslari, kundalik vazifalarni skriptlash", description_ru: "Базовые скрипты автоматизации рутины" },
      { id: '3.5', code: 'CONT_INTEGRATE', name_uz: "Formatlar konvertatsiyasi va integratsiya", name_ru: "Интеграция и конвертация форматов", description_uz: "PDF, JSON, CSV va API formatlari bilan ishlash", description_ru: "Экспорт/импорт между разными системами" },
      { id: '3.6', code: 'CONT_UZB', name_uz: "O'zbek tilida raqamli kontent yaratish", name_ru: "Создание контента на узбекском языке", description_uz: "Lotin yozuvida davlat tili me'yorlariga rioya etish", description_ru: "Грамотность и локализация контента" },
    ]
  },
  {
    id: 4,
    code: 'DIG_SECURITY',
    title_uz: "Kiberxavfsizlik va maxfiylik",
    title_ru: "Кибербезопасность и конфиденциальность",
    weight: 13,
    icon: '🛡️',
    indicatorsCount: 6,
    description_uz: "Shaxsiy va korporativ ma'lumotlarni himoyalash, fishing, 2FA, raqamli gigiyena va sog'liq.",
    description_ru: "Защита персональных и банковских данных, противодействие фишингу, 2FA и цифровая гигиена.",
    indicators: [
      { id: '4.1', code: 'SEC_AUTH', name_uz: "Parollar siyosati va 2FA/MFA", name_ru: "Пароли и двухфакторная аутентификация", description_uz: "Murakkab parollar va autentifikator ilovalari", description_ru: "Менеджеры паролей, OTP-коды и двухфакторная защита" },
      { id: '4.2', code: 'SEC_PHISH', name_uz: "Fishing va ijtimoiy muhandislik", name_ru: "Распознавание фишинга и социальной инженерии", description_uz: "Soxta xatlar, shubhali havolalar va firibgarlarni fosh etish", description_ru: "Анализ вредоносных ссылок, вложений и звонков" },
      { id: '4.3', code: 'SEC_PRIVACY', name_uz: "Shaxsiy ma'lumotlar maxfiyligi (GDPR/Qonun)", name_ru: "Защита персональных данных", description_uz: "Mijozlar ma'lumotlarini tarqatmaslik talablari", description_ru: "Соблюдение законов о тайне и персональных данных" },
      { id: '4.4', code: 'SEC_DEVICE', name_uz: "Qurilmalar va tarmoqlar xavfsizligi", name_ru: "Безопасность устройств и Wi-Fi сетей", description_uz: "Ochiq Wi-Fi da VPN dan foydalanish, antivirus nazorati", description_ru: "Использование VPN в публичных сетях, шифрование" },
      { id: '4.5', code: 'SEC_HEALTH', name_uz: "Ergonomika va raqamli balans", name_ru: "Цифровой детокс и эргономика", description_uz: "Ekran vaqti, ko'rish qobiliyatini asrash va qad-qomat", description_ru: "Баланс экранного времени, здоровье при работе за ПК" },
      { id: '4.6', code: 'SEC_INCIDENT', name_uz: "Xavfsizlik insidentlariga munosabat", name_ru: "Реагирование на инциденты безопасности", description_uz: "Shubhali faoliyat aniqlanganda IT xizmatini ogohlantirish", description_ru: "Протоколы действий при взломе или утечке" },
    ]
  },
  {
    id: 5,
    code: 'DIG_PROBLEM',
    title_uz: "Muammolarni raqamli hal etish",
    title_ru: "Решение проблем цифровыми средствами",
    weight: 16,
    icon: '🧩',
    indicatorsCount: 5,
    description_uz: "Texnik nosozliklarni bartaraf etish, dasturlar tanlash va innovatsion yechimlar ishlab chiqish.",
    description_ru: "Диагностика сбоев, подбор программного обеспечения и креативная автоматизация задач.",
    indicators: [
      { id: '5.1', code: 'PROB_TECH', name_uz: "Texnik muammolarni bartaraf etish", name_ru: "Устранение базовых технических неполадок", description_uz: "Drayverlar, tarmoq ulanishi va kesh muammolarini yechish", description_ru: "Диагностика интернета, периферии, кэша и зависаний" },
      { id: '5.2', code: 'PROB_TOOL', name_uz: "Vazifaga mos dasturiy ta'minot tanlash", name_ru: "Подбор инструментов под бизнес-задачу", description_uz: "Raqamli yechimlarning funksional va narx tahlili", description_ru: "Сравнение SaaS-сервисов и открытых инструментов" },
      { id: '5.3', code: 'PROB_GAP', name_uz: "Kompetensiya bo'shliqlarini aniqlash", name_ru: "Определение пробелов в цифровых навыках", description_uz: "O'z-o'zini baholash va mustaqil malaka oshirish", description_ru: "Самообучение новым цифровым инструментам" },
      { id: '5.4', code: 'PROB_OPTIM', name_uz: "Ish jarayonlarini raqamli optimallashtirish", name_ru: "Оптимизация рабочих процессов", description_uz: "Qog'ozbozlikni kamaytirish va raqamli workflow yaratish", description_ru: "Устранение рутинных шагов с помощью софта" },
      { id: '5.5', code: 'PROB_CRIT', name_uz: "Texnologiyalarni tanqidiy tahlil qilish", name_ru: "Критический анализ технологий", description_uz: "Har qanday vositaning ijobiy va salbiy tomonlarini ko'ra bilish", description_ru: "Оценка рисков внедрения новых IT-решений" },
    ]
  },
  {
    id: 6,
    code: 'DIG_FINTECH',
    title_uz: "Iqtisodiy va moliyaviy raqamli ko‘nikmalar",
    title_ru: "Экономические и финансовые цифровые навыки",
    weight: 18,
    icon: '💳',
    indicatorsCount: 7,
    description_uz: "E-tijorat, bank mobil ilovalari, raqamli to'lovlar, fintech vositalari, billing va kassa tizimlari.",
    description_ru: "Банкинг, электронная коммерция, биллинг, ERP/1C, анализ финансовых потоков и налоги онлайн.",
    indicators: [
      { id: '6.1', code: 'FIN_BANK', name_uz: "Internet-banking va korporativ hisoblar", name_ru: "Интернет-банкинг и корпоративные счета", description_uz: "Bank-mijoz tizimlarida to'lov topshiriqnomalari bilan ishlash", description_ru: "Платежные поручения, выписки и валютный контроль" },
      { id: '6.2', code: 'FIN_PAY', name_uz: "Raqamli to'lov tizimlari (Payme/Click/Uzum)", name_ru: "Платежные шлюзы и эквайринг", description_uz: "QR-to'lovlar, fiskal cheklar va integratsiyalashgan to'lovlar", description_ru: "Эквайринг, фискализация, QR-коды и онлайн-кассы" },
      { id: '6.3', code: 'FIN_ECOM', name_uz: "E-tijorat va marketpleyslarda ishlash", name_ru: "Электронная коммерция и маркетплейсы", description_uz: "Uzum, Zoodmall, Amazon da tovarlar boshqaruvi", description_ru: "Управление листингом, заказами и логистикой" },
      { id: '6.4', code: 'FIN_TAX', name_uz: "Davlat soliq va statistika portallari", name_ru: "Налоговые и статистические онлайн-сервисы", description_uz: "Soliq.uz, didox.uz da hisob-fakturalarni imzolash", description_ru: "ЭДО (электронные счет-фактуры), сдача отчетов онлайн" },
      { id: '6.5', code: 'FIN_BUDGET', name_uz: "Raqamli byudjetlashtirish va prognoz", name_ru: "Цифровое бюджетирование и прогнозирование", description_uz: "Finans modellar, xarajatlar tahlili va rentabellik hisobi", description_ru: "Финансовое моделирование, расчет юнит-экономики" },
      { id: '6.6', code: 'FIN_ERP', name_uz: "Buxgalteriya va ERP tizimlari (1C/Didox)", name_ru: "Работа с учетными системами (1C/ERP)", description_uz: "Ombor, kadrlar va moddiy boyliklarni raqamli hisobi", description_ru: "Ведение первичного учета и складских операций" },
      { id: '6.7', code: 'FIN_FRAUD', name_uz: "Moliyaviy kiberfiribgarlikdan himoyalanish", name_ru: "Защита от финансового мошенничества", description_uz: "Karta ma'lumotlari xavfsizligi va shubhali tranzaksiyalar", description_ru: "Безопасность банковских карт и антифрод-правила" },
    ]
  },
  {
    id: 7,
    code: 'DIG_AI',
    title_uz: "Sun’iy intellekt savodxonligi (AI Literacy)",
    title_ru: "Грамотность в сфере искусственного интеллекта",
    weight: 12,
    icon: '🤖',
    indicatorsCount: 5,
    description_uz: "SI asoslari, prompt-injiniring, biznes jarayonlarga LLM integratsiyasi, generativ SI va axloq.",
    description_ru: "Понимание возможностей ИИ, промпт-инжиниринг, интеграция LLM в бизнес-процессы и этика нейросетей.",
    indicators: [
      { id: '7.1', code: 'AI_CONCEPTS', name_uz: "SI va mashinali o'qitish tushunchalari", name_ru: "Концепции ИИ и машинного обучения", description_uz: "Neyron tarmoqlar qanday ishlashini va ularning cheklovlarini tushunish", description_ru: "Принципы обучения моделей, галлюцинации и ограничения" },
      { id: '7.2', code: 'AI_PROMPTING', name_uz: "Prompt injiniringi va LLM muloqoti", name_ru: "Промпт-инжиниринг и работа с LLM", description_uz: "ChatGPT, Claude, Gemini dan aniq natija olish uchun promp tuzish", description_ru: "Формирование контекста, role-playing и one-shot промпты" },
      { id: '7.3', code: 'AI_BUSINESS', name_uz: "Biznesda SI vositalaridan foydalanish", name_ru: "Применение ИИ в бизнес-задачах", description_uz: "Kopirayting, hisobot xulosalari va tahlilni SI bilan tezlashtirish", description_ru: "Саммаризация отчетов, генерация черновиков и анализ" },
      { id: '7.4', code: 'AI_ETHICS', name_uz: "SI etikasi va xolislik (Bias)", name_ru: "Этика ИИ, предвзятость и авторство", description_uz: "Mualliflik, maxfiy korporativ ma'lumotlarni ochiq SI ga yuklamaslik", description_ru: "Безопасность закрытых данных компании при работе с ИИ" },
      { id: '7.5', code: 'AI_EVAL', name_uz: "SI natijalarini tanqidiy tekshirish", name_ru: "Критическая верификация ответов ИИ", description_uz: "Sun'iy intellekt xatolarini (faktlar buzilishini) tekshirish", description_ru: "Верификация сгенерированных расчетов и фактов" },
    ]
  }
];

export const SAMPLE_CAT_QUESTIONS: AssessmentQuestion[] = [
  // Soha 6: Moliyaviy
  {
    id: 'q6_1',
    areaId: 6,
    difficulty: -0.8,
    discrimination: 1.2,
    question_uz: "Bank kartasining qaysi ma'lumotlarini hech qachon uchinchi shaxslarga (shu jumladan bank xodimlariga ham) aytmaslik kerak?",
    question_ru: "Какие данные банковской карты категорически запрещено сообщать третьим лицам (включая сотрудников банка)?",
    options: [
      { id: 'a', text_uz: "Karta egasining ismi va familiyasi", text_ru: "Имя и фамилия держателя карты", isCorrect: false },
      { id: 'b', text_uz: "Kartaning 16 xonali raqami", text_ru: "16-значный номер карты", isCorrect: false },
      { id: 'c', text_uz: "SMS orqali kelgan bir martalik tasdiqlash kodi va CVV/CVC kodi", text_ru: "Одноразовый код из SMS и код безопасности CVV/CVC", isCorrect: true },
      { id: 'd', text_uz: "Kartaning amal qilish muddati", text_ru: "Срок действия карты", isCorrect: false }
    ],
    explanation_uz: "SMS orqali kelgan OTP kod va CVV karta ustidan to'liq boshqaruv imkonini beradi. Bank xodimlari bu ma'lumotlarni so'rashga haqli emas.",
    explanation_ru: "SMS-код подтверждения и CVV дают полный доступ к списанию средств. Настоящие сотрудники банков никогда не запрашивают эти данные."
  },
  {
    id: 'q6_2',
    areaId: 6,
    difficulty: 0.4,
    discrimination: 1.6,
    question_uz: "Korxona elektron hisob-fakturalarni rasmiylashtirish va imzolash uchun O'zbekistonda qaysi vositadan foydalanadi?",
    question_ru: "Какой инструмент используется в Узбекистане для оформления и юридически значимого подписания электронных счет-фактур?",
    options: [
      { id: 'a', text_uz: "Oddiy elektron pochta (Outlook/Gmail)", text_ru: "Обычная электронная почта (Outlook/Gmail)", isCorrect: false },
      { id: 'b', text_uz: "E-IMZO raqamli imzosi bilan integratsiyalashgan E-hujjat tizimlari (masalan, Didox.uz yoki Soliq.uz)", text_ru: "Системы ЭДО, интегрированные с цифровой подписью E-IMZO (Didox, Soliq.uz)", isCorrect: true },
      { id: 'c', text_uz: "Telegram guruhlarida PDF fayllarni almashish", text_ru: "Отправка подписанных вручную сканов в Telegram", isCorrect: false },
      { id: 'd', text_uz: "Word hujjatidagi skanerlangan imzo tasviri", text_ru: "Вставка картинки подписи в документ Word", isCorrect: false }
    ],
    explanation_uz: "Elektron hisob-faktura yuridik kuchga ega bo'lishi uchun E-IMZO orqali tasdiqlanishi va vakolatli E-faktura operatori orqali yuborilishi shart.",
    explanation_ru: "Только электронная цифровая подпись E-IMZO через аккредитованных операторов ЭДО обеспечивает юридическую силу документов."
  },
  {
    id: 'q6_3',
    areaId: 6,
    difficulty: 1.2,
    discrimination: 1.9,
    question_uz: "Kompaniyaning rentabellik indeksini (PI) baholashda investitsiya loyihasi qachon iqtisodiy jihatdan maqsadga muvofiq hisoblanadi?",
    question_ru: "При анализе индекса рентабельности инвестиций (PI), в каком случае проект считается экономически выгодным?",
    options: [
      { id: 'a', text_uz: "Agar PI < 0 bo'lsa", text_ru: "Если PI < 0", isCorrect: false },
      { id: 'b', text_uz: "Agar PI = 0 bo'lsa", text_ru: "Если PI = 0", isCorrect: false },
      { id: 'c', text_uz: "Agar PI > 1.0 bo'lsa (keltirilgan daromadlar qiymati investitsiyalardan yuqori)", text_ru: "Если PI > 1.0 (дисконтированные денежные притоки превышают затраты)", isCorrect: true },
      { id: 'd', text_uz: "PI ko'rsatkichi investitsiyalar samaradorligiga ta'sir qilmaydi", text_ru: "Индекс PI не связан с целесообразностью", isCorrect: false }
    ],
    explanation_uz: "Rentabellik indeksi PI = PV_inflows / Initial_investment. Agar PI > 1 bo'lsa, NPV > 0 bo'ladi va loyiha foyda keltiradi.",
    explanation_ru: "Индекс рентабельности PI > 1 означает, что чистая приведенная стоимость (NPV) положительна и проект окупает затраты капитала."
  },

  // Soha 7: Sun'iy intellekt
  {
    id: 'q7_1',
    areaId: 7,
    difficulty: -0.5,
    discrimination: 1.3,
    question_uz: "Katta til modellari (LLM, masalan ChatGPT yoki Gemini) bilan ishlashda «gallyutsinatsiya» (AI Hallucination) nima?",
    question_ru: "Что в терминологии больших языковых моделей (LLM, например ChatGPT или Gemini) называется «галлюцинацией»?",
    options: [
      { id: 'a', text_uz: "Modelning haddan tashqari tez javob qaytarishi", text_ru: "Слишком быстрый ответ нейросети", isCorrect: false },
      { id: 'b', text_uz: "Modelning ishonchli ohangda haqiqatga to'g'ri kelmaydigan, to'qima faktlarni bayon qilishi", text_ru: "Уверенная генерация моделью ложных или вымышленных фактов", isCorrect: true },
      { id: 'c', text_uz: "Internet aloqasining uzilishi natijasidagi xatolik", text_ru: "Ошибка из-за обрыва соединения с сервером", isCorrect: false },
      { id: 'd', text_uz: "Matnni bir tildan boshqa tilga noto'g'ri tarjima qilish", text_ru: "Неточный перевод с одного языка на другой", isCorrect: false }
    ],
    explanation_uz: "Gallyutsinatsiya — ehtimollik asosida keyingi so'zni bashorat qiluvchi neyrotarmoqning haqiqatda mavjud bo'lmagan ma'lumotni to'qib chiqarishi. Shu sababli har doim fakt-cheking zarur.",
    explanation_ru: "Галлюцинация — генерация моделью правдоподобно звучащего, но фактически вымышленного текста. Требует обязательной верификации человеком."
  },
  {
    id: 'q7_2',
    areaId: 7,
    difficulty: 0.6,
    discrimination: 1.7,
    question_uz: "Korporativ maxfiy ma'lumotlarni (masalan, mijozlar pasport ma'lumotlari yoki moliyaviy hisobot) ommaviy AI xizmatlariga kiritish qanday asosiy xavfni keltirib chiqaradi?",
    question_ru: "Какой главный риск возникает при отправке конфиденциальных данных клиентов или финансовой отчетности в публичные веб-версии ИИ-сервисов?",
    options: [
      { id: 'a', text_uz: "Neyrotarmoq sekinroq ishlay boshlaydi", text_ru: "Нейросеть станет работать медленнее", isCorrect: false },
      { id: 'b', text_uz: "Ma'lumotlar ommaviy modelni o'qitish bazasiga tushishi va uchinchi shaxslarga oshkor bo'lishi xavfi", text_ru: "Утечка конфиденциальных данных и их возможное включение в обучающую выборку моделей", isCorrect: true },
      { id: 'c', text_uz: "Kompyuter ekraniga zarar yetkazilishi", text_ru: "Сбой операционной системы компьютера", isCorrect: false },
      { id: 'd', text_uz: "Hech qanday xavf yo'q, hamma ma'lumotlar avtomatik o'chiriladi", text_ru: "Никаких рисков, все публичные боты анонимны", isCorrect: false }
    ],
    explanation_uz: "Ommaviy AI platformalari foydalanuvchi kiritgan matnlardan kelajakdagi modellarni o'qitishda foydalanishi mumkin. Korxonalarda Enterprise/lokal modellar talab etiladi.",
    explanation_ru: "Публичные версии чат-ботов часто используют пользовательские промпты для дообучения. Корпоративные тайны разрешено обрабатывать только в изолированных Enterprise-средах."
  },
  {
    id: 'q7_3',
    areaId: 7,
    difficulty: 1.4,
    discrimination: 1.8,
    question_uz: "Sun'iy intellekt asosidagi tabiiy tilni qayta ishlashda (NLP) semantik o'xshashlikni baholash uchun mBERT kabi modellarda qaysi mexanizm asosiy rol o'ynaydi?",
    question_ru: "Какой механизм является основой контекстуального понимания текста и семантической близости в моделях класса mBERT?",
    options: [
      { id: 'a', text_uz: "Oddiy so'zma-so'z moslikni (string match) sanash", text_ru: "Посимвольное сравнение строк", isCorrect: false },
      { id: 'b', text_uz: "Self-Attention (o'z-o'ziga e'tibor) mexanizmi asosidagi kontekstual vektorli embeddinglar", text_ru: "Механизм Self-Attention (трансформер) и контекстуальные векторные эмбеддинги", isCorrect: true },
      { id: 'c', text_uz: "Faqat so'zlar chastotasini hisoblovchi TF-IDF usuli", text_ru: "Только частотный анализ слов (TF-IDF)", isCorrect: false },
      { id: 'd', text_uz: "Fayl hajmini qisqartirish arxivi", text_ru: "Алгоритмы архивирования файлов", isCorrect: false }
    ],
    explanation_uz: "Transformer arxitekturasi va Self-Attention mexanizmi so'zning gapdagi boshqa barcha so'zlar bilan kontekstual bog'liqligini yuqori o'lchovli fazoda modellashtirish imkonini beradi.",
    explanation_ru: "Self-Attention в архитектуре Transformer вычисляет контекстные связи каждого слова со всеми остальными, формируя глубокие семантические представления."
  },

  // Soha 4: Kiberxavfsizlik
  {
    id: 'q4_1',
    areaId: 4,
    difficulty: 0.1,
    discrimination: 1.4,
    question_uz: "Sizga bank xizmati nomidan «Hisobingiz bloklandi, ushbu havolaga o'tib parolingizni tasdiqlang» degan shoshilinch xabar keldi. Eng to'g'ri harakat qanday?",
    question_ru: "Вам пришло срочное сообщение якобы от службы безопасности банка: «Ваш счет заблокирован, перейдите по ссылке и подтвердите пароль». Ваши действия?",
    options: [
      { id: 'a', text_uz: "Darhol havolaga kirib parolni kiritish", text_ru: "Срочно перейти по ссылке и ввести пароль", isCorrect: false },
      { id: 'b', text_uz: "Havolaga kirmaslik, xabarni o'chirish yoki rasmiy bank raqamiga/ilovasiga kirib ma'lumotni tekshirish", text_ru: "Не переходить по ссылке, проверить баланс в официальном приложении банка или позвонить на горячую линию", isCorrect: true },
      { id: 'c', text_uz: "Xabarni barcha hamkasblarga yuborish", text_ru: "Переслать сообщение коллегам в чат", isCorrect: false },
      { id: 'd', text_uz: "Havolani ochib faqat telefon raqamini kiritish", text_ru: "Открыть ссылку в приватном окне и ввести номер телефона", isCorrect: false }
    ],
    explanation_uz: "Bu klassik fishing hujumi. Banklar hech qachon shubhali havolalar orqali parol kiritishni talab qilmaydi.",
    explanation_ru: "Это классический фишинг. Банки никогда не рассылают сторонние ссылки для ввода аутентификационных данных."
  },

  // Soha 1: Ma'lumotlar
  {
    id: 'q1_1',
    areaId: 1,
    difficulty: 0.3,
    discrimination: 1.5,
    question_uz: "Katta ma'lumotlar jadvalida mijozning ID raqami bo'yicha boshqa jadvaldagi telefon raqamini avtomatik topib qo'yish uchun Excel/Google Sheets da qaysi funksiya eng qulay?",
    question_ru: "Какая функция в Excel/Google Sheets наиболее эффективна для подтягивания телефонного номера клиента из другой таблицы по его уникальному ID?",
    options: [
      { id: 'a', text_uz: "SUM yoki COUNT", text_ru: "SUM или СЧЁТ", isCorrect: false },
      { id: 'b', text_uz: "VLOOKUP (ВПР) yoki XLOOKUP (ПРОСМОТРX)", text_ru: "VLOOKUP (ВПР) или XLOOKUP (ПРОСМОТРX)", isCorrect: true },
      { id: 'c', text_uz: "CONCATENATE (СЦЕПИТЬ)", text_ru: "CONCATENATE (СЦЕПИТЬ)", isCorrect: false },
      { id: 'd', text_uz: "PROPER (ПРОПНАЧ)", text_ru: "ПРОПНАЧ", isCorrect: false }
    ],
    explanation_uz: "VLOOKUP/XLOOKUP kalit ustun bo'yicha mos yozuvlarni qidirish va bog'liq ma'lumotlarni jadvalga qo'shish uchun asosiy vositadir.",
    explanation_ru: "Функции вертикального поиска VLOOKUP и современный XLOOKUP сопоставляют записи по ключевому полю между массивами данных."
  }
];

export const SAMPLE_SCENARIOS: ScenarioTask[] = [
  {
    id: 'sc_bank_1',
    areaId: 6,
    title_uz: "Bank mijozi murojaatini xavfsiz raqamli qayta ishlash",
    title_ru: "Безопасная обработка обращения клиента банка",
    scenario_uz: "Mijoz masofadan turib hisob raqami ochish va korporativ kredit to'lovlarini avtomatlashtirish bo'yicha murojaat qildi. Siz bank yoki tashkilot mas'ul xodimi sifatida jarayonni xavfsiz va samarali yo'lga qo'yish uchun qanday raqamli vositalar va xavfsizlik choralarini qo'llaysiz? O'zbekistondagi raqamli xizmatlar (E-IMZO, MyID, Bank-Mijoz) doirasida tushuntiring.",
    scenario_ru: "Клиент обратился для дистанционного открытия корпоративного счета и настройки регулярных автоплатежей. Опишите порядок действий, используемые цифровые сервисы (MyID, E-IMZO, банк-клиент) и меры защиты от мошенничества.",
    keywords_uz: ['myid', 'biometriya', 'e-imzo', 'elektron imzo', 'bank-klient', '2fa', 'xavfsizlik', 'shaxsiy maʼlumotlar', 'didox', 'avtomatik toʻlov'],
    keywords_ru: ['myid', 'биометрия', 'эцп', 'e-imzo', 'банк-клиент', '2fa', 'безопасность', 'персональные данные', 'эдо', 'автоплатеж'],
    sampleExpertAnswer_uz: "Mijozni masofadan MyID biometrik identifikatsiya orqali tasdiqlash, barcha shartnomalarni E-IMZO raqamli imzosi bilan imzolash, korporativ bank-mijoz tizimida 2FA ni faollashtirish hamda didox/soliq orqali elektron hisob-fakturalarni yo'lga qo'yish lozim.",
    sampleExpertAnswer_ru: "Идентификация клиента через биометрию MyID, подписание договоров через государственную ЭЦП E-IMZO, настройка системы Банк-Клиент с обязательной двухфакторной аутентификацией (2FA) и подключение шлюзов автоматических списаний.",
    maxScore: 10
  },
  {
    id: 'sc_ai_1',
    areaId: 7,
    title_uz: "Korxona xodimlari uchun sun'iy intellektdan xavfsiz foydalanish reglamenti",
    title_ru: "Регламент безопасного применения ИИ в коммерческой компании",
    scenario_uz: "Kompaniya rahbariyati tahliliy hisobotlarni tayyorlash va mijozlar bilan muloqotni tezlashtirish maqsadida sun'iy intellektdan (ChatGPT, Claude) foydalanishga ruxsat berdi. Axborot xavfsizligi va xatoliklarning oldini olish uchun xodimlarga qanday 3 ta asosiy qoida va prompt tayyorlash tamoyilini belgilagan bo'lar edingiz?",
    scenario_ru: "Руководство одобрило использование генеративного ИИ сотрудниками для подготовки аналитики и переписки. Какие ключевые правила безопасности данных и принципы верификации ответов вы введете в компании?",
    keywords_uz: ['maxfiy maʼlumot', 'konfidensial', 'prompt', 'fakt-cheking', 'tekshirish', 'mijoz maʼlumotlari', 'etik', 'gallyutsinatsiya', 'mualliflik'],
    keywords_ru: ['коммерческая тайна', 'персональные данные', 'верификация', 'фактчекинг', 'промпт', 'галлюцинации', 'этика', 'enterprise', 'безопасность'],
    sampleExpertAnswer_uz: "1) Hech qachon mijozlar shaxsiy ma'lumotlari va tijorat sirlarini ommaviy modellarga kiritmaslik. 2) Har bir hisob-kitob va faktni insoniy fakt-chekingdan o'tkazish (gallyutsinatsiyani tekshirish). 3) Aniq rol, cheklov va kontekstga ega tuzilmali promptlardan foydalanish.",
    sampleExpertAnswer_ru: "1) Полный запрет на ввод персональных данных клиентов, паролей и финансовой тайны в публичные нейросети. 2) Обязательная ручная проверка (фактчекинг) сгенерированных расчетов перед публикацией. 3) Использование структурированных ролевых промптов с проверкой первоисточников.",
    maxScore: 10
  }
];

export interface EconomicEfficiencyData {
  // Model: E = α * Te + β * A + γ * U
  alpha: number; // 0.2
  beta: number;  // 0.5
  gamma: number; // 0.3
  timeReductionRate: number; // Te = (85 - 38) / 85 = 0.55 (55%)
  modelAccuracyF1: number;   // A = 0.871
  userSatisfactionScore: number; // U = 4.3 / 5 = 0.86
  integralEfficiency: number; // E = 0.2*0.55 + 0.5*0.871 + 0.3*0.86 = 0.8038
  
  // Financial metrics
  initialInvestmentMlnUzs: number; // 890
  annualEconomicBenefitMlnUzs: number; // 1560
  annualOperationalCostMlnUzs: number; // 99
  annualNetCashFlowMlnUzs: number; // 1461
  npv5YearsMlnUzs: number; // ~3680
  profitabilityIndexPI: number; // 5.13
  paybackPeriodMonths: number; // 7.3
  
  // Macro scale (120 corporations)
  macroPotentialAnnualBenefitBlnUzs: number; // ~187 bln UZS
  
  // Organizational benefits breakdown
  hrTimeSavingsMlnUzs: number; // 320
  badHireLossReductionMlnUzs: number; // 580
  targetedTrainingSavingsMlnUzs: number; // 240
  productivityGrowthMlnUzs: number; // 420
}

export const DISSERTATION_BENCHMARKS: EconomicEfficiencyData = {
  alpha: 0.20,
  beta: 0.50,
  gamma: 0.30,
  timeReductionRate: 0.55,
  modelAccuracyF1: 0.871,
  userSatisfactionScore: 0.86,
  integralEfficiency: 0.804,
  
  initialInvestmentMlnUzs: 890,
  annualEconomicBenefitMlnUzs: 1560,
  annualOperationalCostMlnUzs: 99,
  annualNetCashFlowMlnUzs: 1461,
  npv5YearsMlnUzs: 3680,
  profitabilityIndexPI: 5.13,
  paybackPeriodMonths: 7.3,
  
  macroPotentialAnnualBenefitBlnUzs: 187.2,
  
  hrTimeSavingsMlnUzs: 320,
  badHireLossReductionMlnUzs: 580,
  targetedTrainingSavingsMlnUzs: 240,
  productivityGrowthMlnUzs: 420
};

